const EXISTING_VISA_TYPES = {
  continueToAssessmentNode: 'CONTINUE_TO_ASSESSMENT_NODE',
  endNode: 'END_NODE',
  isEligibleNode: 'IS_ELIGIBLE_NODE',
  rootNode: 'ROOT_NODE',
};

export default EXISTING_VISA_TYPES;
